import { AxiosRequestConfig } from "axios";
import ApiConstants from "../constants/ApiConstants";
import http from "../http";


class ComponentGroupsService {

    static apiConfig;
    // Get component group list
    static getComponentGroups() {
        let params = this.apiConfig;
        let url = ApiConstants.URL.TENANT.COMPONENT_GROUP;
        if (params) {
            let paramStr = '';
            let keys = Object.keys(params);
            keys.forEach((key, index) => {
                if (index == 0) {
                    paramStr = `?${[key]}=${params[key]}`
                } else {
                    paramStr = paramStr + `&${[key]}=${params[key]}`
                }

            })
            url = url + paramStr
        }
        return http
            .get(
                `${url}`
            )
            .catch((err: any) => {
                console.error('Error loading component groups ', err);
                return Promise.reject(err);
            });
    }

    static loadComponents() {
        let params = this.apiConfig;
        let url = ApiConstants.URL.PEOPLE.COMPONENT + 'components/tenant';;
        if (params) {
            let paramStr = '';
            let keys = Object.keys(params);
            keys.forEach((key, index) => {
                if (index == 0) {
                    paramStr = `?${[key]}=${params[key]}`
                } else {
                    paramStr = paramStr + `&${[key]}=${params[key]}`
                }

            })
            url = url + paramStr
        }
        return http
            .get(
                `${url}`
            )
            .catch((err: any) => {
                console.error('Error loading component groups ', err);
                return Promise.reject(err);
            });
    }

    static AddComponentGroup(payload) {
        let url = `${ApiConstants.URL.BASE + ApiConstants.URL.PEOPLE.TENANT}/component-group`
        return http.post(url, payload);
    }

    static UpdateComponentGroup(payload) {
        let url = `${ApiConstants.URL.BASE + ApiConstants.URL.PEOPLE.TENANT}/component-group`
        return http.put(url, payload);
    }
}

export default ComponentGroupsService;
